module.exports = __webpack_public_path__ + "img/website.522df516.svg";